import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M5.775 20.5c-.45 0-.898-.18-1.257-.538-.45-.448-.629-1.076-.45-1.614l.899-4.035c.09-.539.359-.987.718-1.346l7.901-7.89a3.58 3.58 0 0 1 5.118 0l.718.716c.719.718 1.078 1.615 1.078 2.511 0 .897-.36 1.883-1.078 2.6l-7.9 7.892c-.36.359-.809.628-1.348.718l-4.04.896c-.09.09-.27.09-.36.09ZM16.1 5.793c-.449 0-.898.18-1.257.539l-7.901 7.89a.493.493 0 0 0-.27.45l-.897 3.855c0 .09 0 .09.09.09l3.86-.897c.18 0 .36-.09.45-.269l7.9-7.891a1.77 1.77 0 0 0 .54-1.256c0-.448-.18-.896-.54-1.255l-.807-.807c-.27-.27-.719-.449-1.168-.449Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m16.772 12.26-4.644-4.55 1.12-1.143 4.644 4.548-1.12 1.144Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgPencil);
export default ForwardRef;
